import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { Controller, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DatePickerCustom from "../../common/components/common/DatePickerCustom";
import CoreAutocomplete from "../../common/components/forms/CoreAutocomplete";
import CoreInput from "../../common/components/forms/CoreInput";
import useCoreContext from "../../common/hooks/useCoreContext";
import { PRIMARY } from "../../theme/colors";
import { UTC_TIME_LIST } from "../constant";
import AvatarUpload from "./AvatarUpload";

const UserInfoForm = () => {
  const { formContextUser, handleSubmitUserInfo, listLanguage, listCountry } =
    useCoreContext();
  const { control, formState, watch } = formContextUser;
  const { t } = useTranslation("common");
  return (
    <Box display="flex" justifyContent="center">
      <Box
        display="flex"
        justifyContent="center"
        style={{ width: "100%", maxWidth: 930 }}
      >
        <FormProvider {...formContextUser}>
          <form onSubmit={handleSubmitUserInfo}>
            <Box className="w-full flex justify-center flex-col items-center">
              <AvatarUpload
                control={control}
                name="imageUrl"
                watch={watch}
                style={{ width: 180, height: 180 }}
              />
              <Typography
                className="mt-10 mb-24"
                variant="body2"
                style={{ maxWidth: 300, textAlign: "center" }}
              >
                <span style={{ color: PRIMARY }}>*</span> Bức ảnh có kích thước
                tối đa 600x600, nặng không quá 800kb
              </Typography>
            </Box>

            <Box>
              <CoreInput
                name="username"
                label={"Username"}
                placeholder={"Username"}
                className="mb-15"
                disabled
                // rules={{
                //   required: "Đây là trường bắt buộc",
                // }}
              />
            </Box>
            <Box className="flex flex-row flex-wrap">
              <CoreInput
                name="firstName"
                label={t("user.name")}
                placeholder={"Họ"}
                className="w-1/2 pb-15 pr-15"
                rules={{
                  required: t("validation.required"),
                }}
              />
              <CoreInput
                name="lastName"
                label={t("user.lastName")}
                placeholder={"Tên"}
                className="w-1/2 pb-15"
                rules={{
                  required: t("validation.required"),
                }}
              />
              <CoreInput
                name="email"
                label={"Địa chỉ Email"}
                placeholder={"Địa chỉ Email"}
                className="w-1/2 pb-15 pr-15"
              />
              <CoreInput
                name="phoneNumber"
                label={"Số điện thoại"}
                placeholder={"Số điện thoại"}
                className="w-1/2 mb-15"
                required
                rules={{
                  required: t("validation.required"),
                }}
              />
              <CoreAutocomplete
                name="gender"
                label={"Giới tính"}
                options={[
                  { id: 1, label: "Nam" },
                  { id: 2, label: "Nữ" },
                ]}
                className="w-1/2 pr-15 mb-15"
              />
              <Controller
                control={control}
                name={"birthday"}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <DatePickerCustom
                    label="Ngày sinh"
                    className="w-1/2 mb-15"
                    value={moment(value, "YYYY-MM-DD")}
                    disableFuture
                    onChange={(val) =>
                      onChange(val?.format("YYYY-MM-DD")) ?? null
                    }
                  />
                )}
              />
              <>
                <CoreAutocomplete
                  control={control}
                  name="lang"
                  label={"Ngôn ngữ mặc định"}
                  placeholder={"Chọn"}
                  options={listLanguage}
                  className="w-1/2 pr-15 mb-15"
                  valuePath={"code"}
                  returnValueType="enum"
                  labelPath={"name"}
                />
                <CoreAutocomplete
                  name="timeZone"
                  label={"Mũi giờ"}
                  placeholder={"Chọn"}
                  valuePath="id"
                  labelPath="name"
                  returnValueType="enum"
                  options={UTC_TIME_LIST}
                  className="w-1/2 mb-15"
                />
              </>
              <CoreAutocomplete
                control={control}
                name="countryCode"
                label={"Quốc gia"}
                placeholder={"Chọn"}
                valuePath="code"
                labelPath="name"
                returnValueType="enum"
                options={listCountry}
                className="w-full mb-15"
              />
            </Box>
            <Box className="flex justify-center w-full">
              <LoadingButton
                className="mt-20 w-120 h-30"
                style={{ borderRadius: 80, marginTop: 40 }}
                disableElevation
                type="submit"
                variant="contained"
                loading={formState.isSubmitting}
              >
                <Typography variant="h6">LƯU THAY ĐỔI</Typography>
              </LoadingButton>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Box>
  );
};

export default UserInfoForm;
